import axios from 'axios'
import { getCookie } from './utils'
import { defaultRequestInterceptor, defaultResponseInterceptor, defaultErrorInterceptor } from './axiosHelpers'

const instance = axios.create({
    withCredentials: true,
    baseURL: process.env.NEXT_PUBLIC_API_URL,
})

instance.interceptors.request.use(
    async (config) => {
        await defaultRequestInterceptor(config)

        try {
            config.params = { ...config.params, assessment_id: getCookie('AID') }
        } catch (e) {}
        return config
    },
    (error) => Promise.reject(error)
)

instance.interceptors.response.use(defaultResponseInterceptor, defaultErrorInterceptor)

export default instance
